

export const ADSomeones = (option: any) => {
  const { label, value } = option
  return {
    label: `${label}'s`,
    value,
    raw: option.raw,
  }
}